module.exports = __webpack_public_path__ + "static/media/0027.54381b98.svg";